import { render, staticRenderFns } from "./BrandsPurchase.vue?vue&type=template&id=4120ae72&scoped=true"
import script from "./BrandsPurchase.vue?vue&type=script&lang=js"
export * from "./BrandsPurchase.vue?vue&type=script&lang=js"
import style0 from "./BrandsPurchase.vue?vue&type=style&index=0&id=4120ae72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4120ae72",
  null
  
)

export default component.exports